/**
 * EDelivery Factory, in the future this factory will be split into two files where will be using react-query.
 */
import axios from "axios";

import RequestFactory from "../../../../react/core/utils/RequestFactory";

// API endpoints
const updateParticipantConsentApi =
    __baseApiUrl__ +
    "/participant-web-services/rest/partialauth/ecommService/updateParticipantConsent";

const retrieveParticipantConsentApi =
    __baseApiUrl__ + "/participant-web-services/rest/partialauth/ecommService/participantConsent/";

//Initial EDelivery data
export const retrieveParticipantConsent = async (gaId) => {
    const method = RequestFactory.HTTP_METHOD.GET;
    const contentType = RequestFactory.HTTP_CONTENT_TYPE.JSON;
    const url = retrieveParticipantConsentApi + gaId;
    const request = RequestFactory.create(url, {}, method, contentType);
    try {
        const res = await axios(request);
        return res.data;
    } catch (err) {
        console.error(JSON.stringify(err));
    }
};

//When PPT updates communication preferences such changing email address.
export const updateParticipantConsent = async (params) => {
    const method = RequestFactory.HTTP_METHOD.POST;
    const contentType = RequestFactory.HTTP_CONTENT_TYPE.JSON;
    const request = RequestFactory.create(updateParticipantConsentApi, params, method, contentType);
    try {
        const res = await axios(request);
        return res;
    } catch (err) {
        console.error(
            JSON.stringify(err),
            "Failed to update participant's communication preferences. Parameters: {0}. Error: {1}"
        );
    }
};
